import React, { useState } from "react";
import axios from "axios";
import { Box, Container, MenuItem, Stack, TextField } from "@mui/material";
import BackBtn from "../../widgets/BackBtn";
import { API_ENDPOINT } from "../../utils/constants";
import { getHeader, toastError } from "../../utils/util";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../widgets/PageTitle";
import WabaTextMsg from "../../widgets/WabaTextMsg";
import MediaSelector from "../../widgets/MediaSelector";

const AutoReplyBuilder = () => {
  const [form, setForm] = useState({
    type: "",
    text: "",
    url: "",
    filename: "",
    response: "",
    templateName: "",
  });
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [replyGroup, setReplyGroup] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.type === "text" && !form.text) {
      toast.error("Please enter body text");
      return;
    }
    try {
      setSubmitting(true);
      const { data } = await axios.post(
        `${API_ENDPOINT}/api/save-reply-message`,
        form,
        getHeader()
      );
      toast.success(data.message);
      setForm({
        type: "",
        response: "",
        text: "",
        url: "",
        filename: "",
        templateName: "",
      });
      navigate(`/home/auto-replies`);
    } catch (err) {
      toastError(err);
      // ⚠️  error feedback
    } finally {
      setSubmitting(false);
    }
  };

  const isTextOnly = form.type === "text";

  return (
    <Container maxWidth="md" sx={{ mt: 2 }}>
      <BackBtn />
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 560,
          mx: "auto",
          p: 3,
        }}
      >
        <PageTitle mb={2}>Create / Update Auto Reply</PageTitle>

        <Stack spacing={2}>
          {/* Type selector */}
          <TextField
            size="small"
            name="response"
            label="Button Text"
            helperText="We will do hard matching with this text"
            value={form.response}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            size="small"
            select
            name="type"
            label="Type"
            value={form.type}
            onChange={handleChange}
            required
          >
            {["text", "image", "document", "video"].map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt.charAt(0).toUpperCase() + opt.slice(1)}
              </MenuItem>
            ))}
          </TextField>

          <WabaTextMsg
            value={form.text}
            onChange={(newV) => {
              setForm((prev) => ({ ...prev, text: newV }));
            }}
          />

          {/* Conditionally shown only for non-text types */}
          {!isTextOnly && (
            <>
              <MediaSelector
                type={form.type}
                onChange={(newV) => {
                  setForm((prev) => ({ ...prev, url: newV }));
                }}
              />
              {form.type === "document" && (
                <TextField
                  size="small"
                  name="filename"
                  label="Filename"
                  value={form.filename}
                  onChange={handleChange}
                  fullWidth
                />
              )}
            </>
          )}

          {/* Always shown */}
          <TextField
            size="small"
            name="templateName"
            label="Template Name"
            value={form.templateName}
            helperText="Please ensure correct template name"
            onChange={handleChange}
            fullWidth
          />

          <LoadingButton
            loading={submitting}
            type="submit"
            variant="contained"
            disabled={submitting || !form.type}
          >
            {submitting ? "Submitting…" : "Submit"}
          </LoadingButton>
        </Stack>
      </Box>
    </Container>
  );
};

export default AutoReplyBuilder;
